module.exports = __webpack_public_path__ + "static/media/aave.cfabd36b.svg";